<template>
  <div id="homePage-3">
    <div class="part-title">
      <h3>青橙无线的产品矩阵</h3>
      <p>深圳市青橙无线科技有限公司</p>
    </div>
    <div class="part-content">
      <div class="part-swiper">
        <div class="swiper-left">
          <p>
            智能手表模组、智能手环模组、
            无线传感模组、有线传输模组。
            综合多种高精度MEMS传感器，采用前沿的人工智能技术，自主研发多模态传感器数据分析算法，具备强大的运动分析、体征分析、睡眠分析、环境分析能力。
            能够感知人体的多项体征参数，包括：脉搏、心率、血压、血氧饱和度，以及人体运动状态参数，包括：运动状态、步数、运动状态、能量消耗、睡眠品质等。
            提供自然流畅的人机交互系统，精准智能的数据分析系统，安全稳定的数据传输系统，安全高可用的后台服务系统。全流程、全方位的保障客户极致体验。
          </p>
        </div>
        <div class="swiper-right">
          <img width="870" height="500" src="~assets/img/banner/qc_watch1.png" alt="sashereman">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTwo',
  data () {
    return {}
  }
}

</script>
<style lang="scss" scoped>
#homePage-3 {
  width: 100%;
  height: 100%;
  padding-top: 120px;
  background: url("~assets/img/banner/bg_diandian.png") center no-repeat,
  linear-gradient(to right, #fff 0, #f1f2f6 100%);
  background-size: cover;
}

.part-title {
  position: relative;
  width: 100%;
  margin-bottom: 65px;
  -webkit-transition: all 1s;
  transition: all 1s;
  text-align: center;

  h3 {
    margin-bottom: 10px;
    font-size: 30px;
    font-weight: 700;
    color: #ff6a00;
  }

  p {
    font-size: 16px;
    color: #acadb3;
  }
}

.part-content {
  position: relative;

  .part-swiper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 35px
  }

  .swiper-left {
    margin: auto;
    text-align: center;

    h3 {
      font-size: 20px;
      font-weight: 700;
      color: #ff6a00;
    }

    .Grader {
      display: inline-block;
      min-width: 83px;
      height: 2px;
      margin: 10px 0;
      margin-top: 15px;
      margin-bottom: 30px;
      background: linear-gradient(to right, #ff6a00 0, #ff6a00 100%);
      background-size: cover;
    }

    p {
      font-size: 14px;
      line-height: 25px;
      max-width: 410px;
      text-align: left;
      color: #95969d;
    }
  }

  .swiper-right {
    margin: auto;
    box-shadow: -20px 20px 40px #ccc;
  }
}
</style>
